import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';
import { LANDING_IMAGES } from '../../lib/landingImages';


export const NeonShowcaseSlider = () => {
  const { theme } = useTheme();
  const gorsel = theme === 'dark' ? LANDING_IMAGES.showcaseDark : LANDING_IMAGES.showcaseLight;

  return (
    <section
      className="relative py-16 sm:py-24 overflow-hidden"
      data-testid="v2-showcase-slider"
    >
      {/* Ambient backdrop */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[600px] rounded-full blur-[160px] bg-fuchsia-500/10 dark:bg-fuchsia-700/25 dark:animate-neon-pulse" />
        <div className="absolute top-0 right-0 w-[420px] h-[420px] rounded-full blur-[120px] bg-orange-400/10 dark:bg-orange-600/15" />
        <div className="absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full blur-[120px] bg-indigo-400/10 dark:bg-indigo-700/20" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="overflow-hidden rounded-3xl border border-border dark:border-fuchsia-500/20 shadow-[0_8px_40px_rgba(176,38,255,0.12)] dark:shadow-[0_0_80px_rgba(176,38,255,0.25)]"
          key={theme}
        >
          <img
            {...gorsel}
            sizes="(min-width: 1200px) 1152px, 100vw"
            alt="AgrosJet field operations"
            className="block w-full h-auto object-contain"
            loading="lazy"
            decoding="async"
            data-testid="v2-showcase-image"
          />
        </motion.div>
      </div>
    </section>
  );
};
